<div class="booking-details-save-form">
    <form [formGroup]="form">
        <div class="text-uppercase font-weight-bold" translate>CourtBookingSave.BookingDetailsLabel</div>
        <div class="d-flex flex-row mt-2">
            <div class="row flex-grow-1">
                <div class="col">
                    <label translate>CourtBookingSave.DateLabel</label>
                    <bcui-date-picker-input id="date" [form]="form.controls.date" [inputDateFormat]="'MM/DD/YYYY'"
                        [inputMask]="'00/00/0000'"></bcui-date-picker-input>
                </div>
                <div class="col">
                    <label translate>CourtBookingSave.CourtNameLabel</label>
                    <bcu-drop-down-cf2 [isDisabled]="!isMainPlayerSelected" formControlName="courtId"
                        [options]="(courts$ | async).items" valueKey="courtId" displayKey="name"></bcu-drop-down-cf2>

                </div>
            </div>
        </div>
        <div class="d-flex flex-row mt-2">
            <div class="row flex-grow-1">
                <div class="col">
                    <label translate>CourtBookingSave.TypeLabel</label>
                    <bcu-drop-down-cf2 [isDisabled]="!(typeSelectEnabled$ | async)" formControlName="categoryOptionsId"
                        [options]="(courtOptions$ | async)" valueKey="categoryOptionsId"
                        displayKey="name"></bcu-drop-down-cf2>

                </div>
                <div class="col">
                    <label translate>CourtBookingSave.TimePeriodLabel</label>
                    <bcu-drop-down-cf2 [isDisabled]="!(timePeriodEnabled$ | async)" formControlName="timeSlot"
                        [options]="(timeSlots$ | async)" valueKey="courtTimeSlotId"
                        displayKey="name"></bcu-drop-down-cf2>
                </div>
            </div>
        </div>
        <div class="d-flex flex-col mt-2">
            <div class="row flex-grow-1">
                <div class="col">
                    <div class="row">
                        <div class="col time-dropdown-container" #timeDropdownContainer (click)="updateTimeDropdownPosition()">
                            <label translate>CourtBookingSave.TimeLabel</label>
                            <bcu-drop-down-cf2 [isDisabled]="!(timeEnabled$ | async)"
                                formControlName="timeFromInMinutes" [options]="(availableTimeSlots$ | async).items"
                                valueKey="timeFromInMinutes" displayKey="displayName"
                                maxHeigth="300"></bcu-drop-down-cf2>
                        </div>
                        <div class="col"></div>
                    </div>
                    <div class="row" *ngIf="hasNoAvailableTimeSlots$ | async">
                        <div class="col" translate>CourtBookingSave.NoSlotsAvailable</div>
                    </div>
                    <div class="row" *ngIf="isSelectedTimeSlotUnavailable$ | async">
                        <div class="col light-red py-1" translate>
                            <span class="ic-exclamation-red mr-1">
                            </span>{{selectedTimeSlotUnavailabilityMessage$ | async}}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </form>
</div>